/* eslint-disable */

import addSubscriptionUser from '@/components/private/add-subscription/';
import { bus } from '@/main';
import countries from '@/services/country.json'
import { mapGetters } from 'vuex';
import toast from '@/services/toast';

export default {
  name: 'user-list-table',
  components: {
    'add-subscription-user': addSubscriptionUser
  },
  props: [],
  data() {
    return {
      userList:null,
      email: '',
      password: '',
      submitted: false,
      userListResults:[],
      is_active: Boolean,
      countryList: [],
      userSubscribeForm: false,
      selectedEmail: '',
      activeStatus: Boolean,
    }
  },
  computed: {
    ...mapGetters([
      'getdahboardUserListState',

    ]),
    getUserList() {
     this.userList = this.$store.getters.getdahboardUserListState.data;
     return;
    },
    SetIntialStatus() {
      if (this.userList) {
        this.userListResults = this.userList.results
      }
      return;
    }
  },
  mounted() {
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    this.getUserList
    this.SetIntialStatus
    bus.$on('HideAddSubscriptionPopup', (data) => {
      this.userSubscribeForm = data;
    });
  },
  methods: {
    getUserListAgainMethod() {
      this.$store.dispatch('getUserListDetailsOfDashboard')
    },
    userActStatusMethod(id) {
      let activeStatusUserId = '';
      this.activeStatusUserId = id;
      let data = {
        id: this.activeStatusUserId
      }
      this.$store.dispatch('getUserListDetailsById', data)
        .then((res) => {
          this.activeStatus = this.$store.getters.getUserDetailsByIdState.data.user_details.is_active
          if (this.activeStatus === true) {
            this.is_active = false
          }
          if (this.activeStatus === false) {
            this.is_active = true
          }
          let data = {
            is_active: this.is_active,
          }
          this.$store.dispatch('UpdateUserDetailsById', {
            data: {
              data: data,
              id: id
            }
          }).then((res) => {
            if (res.status == '200') {
              this.$store.dispatch('getDashboardDetails')
              this.getUserListAgainMethod()
              toast.success("User Status Updated Successfully");
            }
          }).catch((err) => {})
          return
        }).catch((err) => {})
    },
    updateSubscriptionStatus(userId, $event, emailId) {
      if (!$event.target.checked) {
        let data = {
          id: userId
        }
        this.$store.dispatch('getUserSubscriptionById', data)
          .then((res) => {
            console.log(res)
            if (res.data.code == 2000) {
              this.getUserListAgainMethod()
              toast.success("User Subscription Updated Successfully");
            }
            return
          }).catch((err) => {})
      } else {
        this.userSubscribeForm = true;
        this.selectedEmail = emailId;
        this.getUserListAgainMethod()
        $event.preventDefault();
      }
    },
    // getCountryFlag: function(countryCode, type) {
    //   if (countryCode == null) {
    //     countryCode = ''
    //   }
    //   let countryName = countryCode.toLowerCase()
    //   let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
    //   if (country && country.length > 0) {
    //     country = country[0]
    //     if (type == 'flag') {
    //       country = `https://567c9b4f06e54c9c9229fe11191a6432.s3.ca-central-1.amazonaws.com/media/flags/${country.value}.svg`
    //     } else {
    //       country = country.name
    //     }
    //   } else {
    //     country = ''
    //   }
    //   return country;
    // }
  },
  beforeMount() {
    this.getUserList;
  },
  watch: {
    getUserList() {
      return this.$store.getters.getdahboardUserListState
    },
    SetIntialStatus() {
      if (this.userList) {
        this.userListResults = this.userList.results
      }
      return;
    }
  }
}